export const OriginOptions = [
  { value: 'anymarket', text: 'ANYMARKET' },
  { value: 'api', text: 'API' },
  { value: 'manual', text: 'MANUAL' },
];

export default OriginOptions;
